import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { sellerCollectionUrl } from "../../util/url";

/**
 * 셀러 컬렉션 탭 컴포넌트
 *
 * @param {Object} props
 * @param {Array} props.collections - 컬렉션 목록 데이터
 * @param {number|string} props.activeTab - 현재 활성화된 탭 ID
 */
const SellerTabs = ({ collections, activeTab }) => {
  const navigate = useNavigate();

  if (!collections) {
    return null;
  }

  if (collections.length === 0) {
    return null;
  }

  return (
    <div className="tabs-container">
      <div className="tabs">
        {collections.map((collection) => {
          const isActive = Number(activeTab) === Number(collection.id);

          return (
            <button
              key={collection.id}
              className={`tab ${isActive ? "active" : ""}`}
              onClick={() => navigate(`${sellerCollectionUrl(collection)}`)}
            >
              {collection.tab_name}
              {isActive && <span className="tab-indicator" />}
            </button>
          );
        })}
      </div>
    </div>
  );
};

SellerTabs.propTypes = {
  collections: PropTypes.array,
  activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SellerTabs;
